package org.example.zone360.pages.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.icons.fa.FaAngleRight
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.window
import kotlinx.coroutines.delay
import org.example.zone360.components.CoachTalkDetailsModal
import org.example.zone360.components.widgetTitleFontSize
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.CoachTalkRatioData
import org.example.zone360.models.WidgetDetailResponse
import org.example.zone360.models.WidgetTrend
import org.example.zone360.pages.dashboard.chart.GaugeChart
import org.example.zone360.pages.dashboard.chart.MiniBars
import org.example.zone360.pages.widgets.helper.WidgetTooltipIcon
import org.example.zone360.pages.widgets.helper.getStatus
import org.example.zone360.theme.Palette
import org.example.zone360.theme.toSitePalette
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.CheckboxInput
import org.w3c.dom.HTMLInputElement

@Composable
fun CommonWidgetCard(
    data: CoachTalkRatioData,
    detailResponse: WidgetDetailResponse? = null,
    modifier: Modifier = Modifier,
//    coachesData: List<GetClubCoachesData>,
    widgetNo: Int,
    widgetName: String,
    widgetGaugeID: String,
    widgetColor: Color,
    sessionBorder: Boolean = false,
    isTalk: Boolean,
    widgetKey: String,
    isCoachPage: Boolean = false,
    showSelection: Boolean = false,
    forceFullWidth: Boolean = false,
    trendData: List<WidgetTrend> = emptyList(),
    isSelected: Boolean = false,
    onSelectionChange: ((Boolean) -> Unit)? = null,
    tooltipText: String = "",
    tooltipTitle: String = "Info"
) {
    val scope = rememberCoroutineScope()
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()
    var isModalOpen by remember { mutableStateOf(false) }

    var widgetDetailResponse by remember { mutableStateOf<WidgetDetailResponse?>(null) }
    val targetParts = data.target.replace("%", "").split("-")
    val minTarget = targetParts[0].toInt()
    val maxTarget = targetParts[1].toInt()

    val status = getStatus(data.clubAverage, minTarget, maxTarget)
    var animatedValue by remember { mutableStateOf(0) }

    LaunchedEffect(data.value) {

        if (data.value > 0) {
            for (i in 0..data.value) {
                animatedValue = i
                delay(5) // speed
            }

        } else {
            animatedValue = 0
        }
    }

    Box(
        modifier = modifier
            .then(
                when {
                    forceFullWidth -> Modifier.fillMaxWidth()   // ✅ session detail
                    sessionBorder -> Modifier.fillMaxWidth()    // ✅ session border card
                    else -> Modifier.minWidth(                  // ✅ normal dashboard
                        when {
                            breakpoint < Breakpoint.MD -> 320.px
                            showSelection -> 280.px
                            window.screen.width in 1200..1500 -> 318.px
                            else -> 350.px
                        }
                    )
                }
            )
            .backgroundColor(sitePalette.modalBackgroundColor.rgb)
            .borderRadius(if (showSelection) 12.px else 16.px)
            .padding(if (showSelection) 12.px else if (sessionBorder) 15.px else 20.px)
            .border(
                if (showSelection) 2.px else if (sessionBorder) 1.px else 0.px,
                LineStyle.Solid,
                color = Palette.CardBorder.rgbLight
            )
            .then(
                when {
                    breakpoint < Breakpoint.MD -> Modifier
                    sessionBorder -> Modifier.height(285.px)
                    !showSelection -> Modifier.height(380.px)
                    else -> Modifier
                }
            )
            .styleModifier {
                property("position", "relative")
            }
    )
    {
        if (showSelection) {
            Box(
                modifier = Modifier
                    .styleModifier {
                        property("position", "absolute")
                        property("top", "9px")
                        property("right", "9px")
                        property("cursor", "pointer")
                    }
                    .zIndex(9999)
            ) {

                CheckboxInput(
                    checked = isSelected
                ) {
                    onChange { event ->
                        onSelectionChange?.invoke(
                            (event.target as HTMLInputElement).checked
                        )
                    }

                    style {
                        property("transform", "scale(1.4)")
                        property("cursor", "pointer")
                    }
                }
            }
        }
        Column(modifier = Modifier.fillMaxWidth().then(
            if (breakpoint < Breakpoint.MD) Modifier
            else Modifier.height(if (showSelection) 350.px else 340.px)
        ))
        {
            // Header row with badge + title
            Row(
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier.fillMaxWidth().margin(bottom = 12.px)
            ) {
                Box(
                    modifier = Modifier
                        .width(if (sessionBorder) 24.px else 28.px)
                        .height(if (sessionBorder) 24.px else 28.px)
                        .backgroundColor(widgetColor)
                        .borderRadius(6.px)
                        .margin(right = 10.px),
                    contentAlignment = Alignment.Center
                ) {
                    FieldTitleTextNormalSimple(
                        text = widgetNo.toString(),
                        fontSize = 14.px,
                        fontWeight = 700,
                        color = sitePalette.bodyBackgroundSecondary.rgb
                    )
                }
                FieldTitleTextNormalSimple(
                    text = widgetName,
                    fontSize = widgetTitleFontSize(showSelection, sessionBorder, breakpoint),
                    fontWeight = 700
                )
                if (!showSelection) {
                    Box(modifier = Modifier.weight(1f))
                }
                if (tooltipText.isNotEmpty()) {
                    WidgetTooltipIcon(
                        tooltipText = tooltipText,
                        tooltipTitle = tooltipTitle,
                        modifier = Modifier.margin(left = 8.px)
                    )
                }
            }

            // Gauge, centered
            Column(
                modifier = Modifier.fillMaxWidth().margin(bottom = 8.px)
                    .then(
                        if (showSelection) Modifier.height(250.px)
                        else Modifier
                    ),
                horizontalAlignment = Alignment.CenterHorizontally,
            ) {
                val actualGaugeId =
                    if (showSelection)
                        "${widgetGaugeID}_${widgetNo}_popup"
                    else
                        "${widgetGaugeID}_${widgetNo}"
                GaugeChart(
                    chartId = actualGaugeId,
                    value = animatedValue,
                    minTarget = minTarget,
                    maxTarget = maxTarget,
                    showSelection = showSelection,
                    sessionBorder = sessionBorder
                )

                FieldTitleTextNormalSimple(
                    text = "Target Range: ${data.target}",
                    fontSize = 14.px,
                    fontWeight = 500,
                    color = Palette.CoachTalkTableHeaderText.rgbLight
                )
                val statusBackgroundColor = when (status.text) {
                    "Accurate" -> Palette.CoachTalkSuccessGreen.rgbLight
                    "High" -> Palette.CoachTalkSuccessGreen.rgbLight
                    "Low" -> Palette.CoachTalkErrorRed.rgbLight
                    else -> status.color
                }

                val statusIcon = when (status.text) {
                    "Accurate" -> "✓"
                    "High" -> "✓"
                    "Low" -> "✕"
                    else -> "✓"
                }

                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier.margin(top = 10.px, bottom = 14.px)
                ) {
                    FieldTitleTextNormalSimple(
                        text = "Status: ${status.text}",
                        fontSize = 14.px,
                        fontWeight = 700,
                        color = status.color
                    )

                    Box(
                        modifier = Modifier
                            .margin(left = 6.px)
                            .width(20.px)
                            .height(20.px)
                            .borderRadius(50.percent)
                            .backgroundColor(statusBackgroundColor),
                        contentAlignment = Alignment.Center
                    ) {
                        SpanText(
                            text = statusIcon,
                            modifier = Modifier
                                .fontSize(12.px)
                                .fontWeight(700)
                                .color(Palette.White.rgbLight)
                        )
                    }
                }
            }
            Spacer()

            // Footer - View Details
            if (!sessionBorder) {
                if (isCoachPage) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .margin(top = if (showSelection) 4.px else 0.px),
                        contentAlignment = Alignment.Center
                    ) {
                        Box(
                            modifier = Modifier
                                .cursor(Cursor.Pointer)
                                .margin(top = 4.px)
                        ) {
                            MiniBars(
                                color = widgetColor,
                                trends = trendData
                            )
                        }
                    }

                } else {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(42.px)
//                            .margin(top = 16.px)
                            .backgroundColor(Palette.ViewDetailBackground.rgbLight)
                            .borderRadius(10.px)
                            .border(
                                1.px,
                                LineStyle.Solid,
                                color = Palette.ViewDetailBorder.rgbLight
                            )
                            .cursor(Cursor.Pointer)
                            .onClick {
                                isModalOpen = true
                            }
                    )
                    {

                        // Centered text
                        Box(
                            modifier = Modifier.fillMaxSize(),
                            contentAlignment = Alignment.Center
                        ) {
                            FieldTitleTextNormalSimple(
                                text = "View Details",
                                fontSize = 14.px,
                                fontWeight = 600,
                                color = Palette.ViewDetailText.rgbLight
                            )
                        }

                        // Right aligned arrow
                        Box(
                            modifier = Modifier
                                .fillMaxHeight()
                                .fillMaxWidth()
                                .padding(right = 14.px),
                            contentAlignment = Alignment.CenterEnd
                        ) {
                            FaAngleRight(
                                modifier = Modifier
                                    .width(14.px)
                                    .height(14.px)
                                    .color(Palette.ViewDetailAngle.rgbLight)
                            )
                        }
                    }
                }
            }
        }
    }

    if (isModalOpen) {
        CoachTalkDetailsModal(
            widgetNo = widgetNo,
            widgetName = widgetName,
            widgetColor = widgetColor,
            widgetGaugeID = "${widgetGaugeID}_detail",
            data = data,
            widgetKey = widgetKey,
            coaches = null,
            isTalk = isTalk,
            minTarget = minTarget,
            maxTarget = maxTarget,
            statusText = status.text,
            statusColor = status.color,
            onClose = { isModalOpen = false }
        )
    }
}
